export * from './quiz-tab-item';
